@for (item of data | evaluationAggregate: 'starRatingItems'; track item) {
  <div>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="aggregate-item"
    >
      @if (item.answers.length > 0) {
        <p class="item-title">
          {{ item.questionName }}
        </p>
      }
      @if (item.answers.length > 0) {
        <app-star-rating-aggregate-item
          [answers]="item.answers"
        ></app-star-rating-aggregate-item>
      }
    </div>
    <mat-divider></mat-divider>
  </div>
}
@for (item of data | evaluationAggregate: 'enumeratedItems'; track item) {
  <div>
    <div class="aggregate-item">
      <p class="item-title">{{ item.questionName }}</p>
      <app-enumerated-aggregate-item
        [questionId]="item.questionId"
        [answers]="item.answers"
        [evaluatorsCount]="data.evaluatorsCount"
      ></app-enumerated-aggregate-item>
    </div>
    <mat-divider></mat-divider>
  </div>
}
@for (item of data | evaluationAggregate: 'otherItems'; track item) {
  <div>
    <div class="aggregate-item">
      <p class="item-title">{{ item.questionName }}</p>
      @for (answer of item.answers; track answer) {
        <p [innerHTML]="answer | safeHtml" style="padding-left: 15px"></p>
      }
    </div>
    <mat-divider></mat-divider>
  </div>
}
